module.exports = __webpack_public_path__ + "static/media/return.24581f43.svg";